import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { HeadersService } from '../../shared/utilities/HeadersService';
import { BaseRestService } from '../../shared/services/BaseRestService';
import { PtrsResponse } from '../models/ptrs/PtrsApiResponse';
import { JsonApiWrap } from '../../shared/models/JsonApiWrap';
import { TransInquiryResponse } from '../../transaction-view/models/TransInquiryResponse';
import { TransInquiryRequest } from '../../transaction-view/models/TransInquiryRequest';
import { IntegrationService } from '../../shared/services/integration.service';

@Injectable({
  providedIn: 'root',
})
export class PtrsService {
  mmExperienceApiPath: string = 'api/ria.MoneyMovementExperience';
  ptrsPath: string = 'api/ria.MoneyMovement/PTRS';

  constructor(
    private http: HttpClient,
    private headersService: HeadersService,
    private baseService: BaseRestService,
    private integrationService: IntegrationService
  ) { }

  callPtrs(accountId: string): Observable<PtrsResponse> {
    const header = this.getHeadersWithClientIds(`SUB=${accountId}`);
    const headers = new HttpHeaders(header);
    const url = `${this.integrationService.JfkEnv.BaseUrl}${this.mmExperienceApiPath
      }/v1/ptrs?${encodeURIComponent('accountNumber')}=${encodeURIComponent(
        '$SUB'
      )}`;

    return this.http
        .get<JsonApiWrap<PtrsResponse>>(url, { headers })
        .pipe(map((res) => res.data.attributes));
  }

  public getHeadersWithClientIds(clientIds: string): {
    [name: string]: string;
  } {
    // TODO: update environment with env variable once set up
    var headers =
      this.headersService.createHeadersWithJsonApiContentSharedToken(
        '1'
      );
    headers['Cache-Control'] = 'no-cache';
    headers['Schwab-Client-Ids'] = clientIds;
    headers['Is-Create-Sloa'] = 'true';
    headers['Is-Bundled-Sloa'] = 'true';
    return headers;
  }
}
